import { render, staticRenderFns } from "./echarI.vue?vue&type=template&id=05c72afe"
import script from "./echarI.vue?vue&type=script&lang=js"
export * from "./echarI.vue?vue&type=script&lang=js"
import style0 from "./echarI.vue?vue&type=style&index=0&id=05c72afe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports